import { Link } from "react-router-dom";
import { ShieldCheck } from "lucide-react";
import { FadeIn, Kicker, SectionShell, MaskedLine } from "../components/Reveal";
import { useI18n } from "../lib/i18n";
import SEO from "../components/SEO";

export default function PrivacyPolicy() {
  const { d } = useI18n();
  const p = d.privacy;

  return (
    <main data-testid="privacy-page">
      <SEO page="privacy" />
      <section className="pt-36 pb-16">
        <div className="mx-auto max-w-4xl px-6 sm:px-10">
          <div className="flex items-center gap-3">
            <ShieldCheck size={20} className="text-crimson dark:text-stalk" />
            <Kicker>{p.kicker}</Kicker>
          </div>
          <h1 className="mt-8 font-display text-4xl font-bold leading-[0.95] tracking-tight sm:text-5xl" data-testid="privacy-headline">
            <MaskedLine delay={0.2}>{p.titleA}<span className="font-serif font-medium italic text-crimson dark:text-stalk">{p.titleAccent}</span></MaskedLine>
          </h1>
          <FadeIn delay={0.4}>
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground">{p.intro}</p>
            <p className="mt-4 font-mono text-[10px] uppercase tracking-[0.25em] text-muted-foreground" data-testid="privacy-updated">{p.updated}</p>
          </FadeIn>
        </div>
      </section>

      <SectionShell className="border-t border-border !py-16">
        <div className="mx-auto max-w-4xl">
          {p.sections.map((sec, i) => (
            <FadeIn key={sec.h} delay={i * 0.04} className="grid gap-4 border-t border-border py-10 first:border-0 first:pt-0 md:grid-cols-[80px_1fr_1.6fr]" data-testid={`privacy-section-${i}`}>
              <span className="font-serif text-4xl italic text-foreground/15">{String(i + 1).padStart(2, "0")}</span>
              <h2 className="font-display text-lg font-semibold">{sec.h}</h2>
              <ul className="space-y-3 text-sm leading-relaxed text-muted-foreground">
                {sec.body.map((b) => (
                  <li key={b} className="flex gap-3">
                    <span className="mt-2 h-1 w-1 shrink-0 bg-crimson dark:bg-stalk" />
                    {b}
                  </li>
                ))}
              </ul>
            </FadeIn>
          ))}
          <FadeIn delay={0.2} className="mt-6 border border-border bg-card/40 p-6">
            <Link to="/#join" data-testid="privacy-contact-cta" className="u-link font-mono text-xs uppercase tracking-[0.25em] text-crimson dark:text-stalk">
              {d.transparency.contact.cta} →
            </Link>
          </FadeIn>
        </div>
      </SectionShell>
    </main>
  );
}
